import React, { useEffect } from 'react';
import { Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import { useTranslation } from 'react-i18next';
//helpers
import { capitalize } from 'helpers';
//constants
import { responsive } from '../../constants';
//custom-hook
import useAssignedLibrary from 'utils/customHooks/useAssignedLibrary';
// own components
import ItemList from 'components/itemList/item';

const ListHome = (props) => {
  const { data } = props;
  const { t } = useTranslation(['home']);
  const { assignedLibrary } = useAssignedLibrary();

  function preloadImages(element) {
    let img = new Image();
    img.src = element;
  }

  useEffect(() => {
    if (data?.length > 0) {
      const productImgs = data?.map((x) => x.get_url);
      productImgs.forEach((element) => preloadImages(element));
    }
  }, [data]);

  return (
    <section className="margin-bottom-md list-section container-fluid list-home p-0">
      <Row className="mb-3">
        <Col xs={12} sm={12} md={12} className="d-flex d-md-none mb-3 justify-content-center align-items-center">
          <Link
            className="link-more"
            to={`/${assignedLibrary}/lista/products_by_list?title=${encodeURIComponent(data?.nombre)}`}
            state={{ list: data?.id.toString() }}
          >
            {t('watchAll')}
          </Link>
        </Col>
        <Col xs={12} sm={12} md={9} className="p-0">
          <h3>{capitalize(data?.nombre)}</h3>
        </Col>
        <Col xs={12} sm={2} className="d-none d-md-flex justify-content-end align-items-center">
          <Link
            className="link-more"
            to={`/${assignedLibrary}/lista/products_by_list?title=${encodeURIComponent(data?.nombre)}`}
            state={{ list: data?.id.toString() }}
          >
            {t('watchAll')}
          </Link>
        </Col>
      </Row>
      <Col xs={12} sm={12} className="p-0">
        <Carousel
          responsive={responsive}
          slidesToSlide={1}
          minimumTouchDrag={40}
          draggable
          infinite={true}
          centerMode={true}
          swipeable
        >
          {data?.products?.map((productDetails, index) => (
            <div key={`productItem#${index}`} className="slide-div mx-2">
              <ItemList data={productDetails} />
            </div>
          ))}
        </Carousel>
      </Col>
    </section>
  );
};

export default ListHome;
